import React from "react";
import { useTranslation } from "../../context/TranslationContext";
import { Truck, Package, Box, Car } from "lucide-react";
import Section from "../ui/Section";
import InfoCard from "../ui/InfoCard";
import FleetImage from "../../assets/image3.jpeg";
import LeafImage from "../../assets/leaf.png";
//Logos
import DafLogo from "../../assets/logos/daf.svg";
import MercedesLogo from "../../assets/logos/mercedes.svg";
import VolvoLogo from "../../assets/logos/volvo.svg";
import IvecoLogo from "../../assets/logos/iveco.svg";
import FordLogo from "../../assets/logos/ford.svg";
import ScaniaLogo from "../../assets/logos/scania.svg";
import RenaultLogo from "../../assets/logos/renault.svg";

const Fleet: React.FC = () => {
  const { t } = useTranslation();

  const vehicles = [
    {
      icon: <Truck className="w-6 h-6" />,
      title: t("fleet.vehicles.truck.title"),
      description: t("fleet.vehicles.truck.description"),
    },
    {
      icon: <Package className="w-6 h-6" />,
      title: t("fleet.vehicles.van.title"),
      description: t("fleet.vehicles.van.description"),
    },
    {
      icon: <Box className="w-6 h-6" />,
      title: t("fleet.vehicles.trailer.title"),
      description: t("fleet.vehicles.trailer.description"),
    },
    {
      icon: <Car className="w-6 h-6" />,
      title: t("fleet.vehicles.specialized.title"),
      description: t("fleet.vehicles.specialized.description"),
    },
  ];

  const brands = [
    {
      name: "Iveco",
      logo: IvecoLogo,
    },
    {
      name: "Mercedes",
      logo: MercedesLogo,
    },
    {
      name: "Scania",
      logo: ScaniaLogo,
    },
    {
      name: "Volvo",
      logo: VolvoLogo,
    },
    {
      name: "Renault",
      logo: RenaultLogo,
    },
    {
      name: "Ford",
      logo: FordLogo,
    },
    {
      name: "DAF",
      logo: DafLogo,
    },
  ];

  return (
    <Section id="fleet" background="dark">
      <div className="text-center mb-12">
        <h2 className="headline mb-6">{t("fleet.title")}</h2>
        <p className="section-description mx-auto">{t("fleet.description")}</p>
        <div className="h-full flex items-center justify-center mx-auto mt-10">
          <div className="inline-block px-4 py-2 bg-white rounded-full shadow-sm">
            <p className="text-neutral flex text-green gap-1 items-center justify-center font-semibold ">
              <img src={LeafImage} width={20} height={20} />
              {t("fleet.euro6Compliant")}
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row gap-8">
        <div className="flex flex-col lg:w-1/2 gap-4">
          <div className="flex flex-col gap-4">
            {vehicles.map((vehicle, index) => (
              <InfoCard
                key={index}
                title={vehicle.title}
                variant="default"
                description={vehicle.description}
              />
            ))}
          </div>
          <div className="mt-auto hidden 2xl:block">
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-7 gap-4">
              {brands.map((brand, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow text-center"
                >
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="h-full w-full mx-auto object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="lg:w-1/2 rounded-lg overflow-hidden">
          <img src={FleetImage} />
        </div>
      </div>
      <div className="2xl:hidden mt-10">
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-7 gap-4">
          {brands.map((brand, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow text-center"
            >
              <img
                src={brand.logo}
                alt={brand.name}
                className="h-full w-full mx-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Fleet;
